import { Component, OnInit, ViewChild } from '@angular/core';
import { divIcon, icon, Map, marker, tileLayer } from 'leaflet';
import { ActivatedRoute } from '@angular/router';
import { ContentService } from '../../services/content.service';
import { GetContentsRequest } from 'src/app/models/getContentsRequest';
import { ContentsResults } from 'src/app/models/contentResults';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { TypeContents } from '../../models/typeContents';
import { IonModal, ModalController } from '@ionic/angular';
import { DepartmentModal } from '../../modals/department-moda';
import { DateHelper } from 'src/app/helpers/date.helper';
import { PlaceEventsComponent } from 'src/app/modals/place-events/place-events.component';
import { LocationAccuracy } from '@awesome-cordova-plugins/location-accuracy/ngx';
import { LoadDataService } from '../../services/load-data.service';
import { Tag } from 'src/app/models/content';

@Component({
  selector: 'app-results',
  templateUrl: './results.page.html',
  styleUrls: ['./results.page.scss'],
})
export class ResultsPage implements OnInit {

  @ViewChild('modalFilters') modalFilters: IonModal;
  
  list = true;

  // Map code
  map: Map;

  // Filtros
  filtro = null;
  filtroName = '';
  filtroUbicacion = null;
  filtroFecha = null;
  filtroExperiencia = null;

  searchTxt = '';
  tagId = 0;
  dapartmentId = null;

  dateFrom = '';
  dateTo = '';

  // Resultados
  results: ContentsResults[] = [];

  // Contents
  typeContents: TypeContents[] = [];

  // Geolocations
  userCoords = {} as GeolocationCoordinates;

  constructor(
    private activatedRoute: ActivatedRoute,
    private contentService: ContentService,
    private geolocation: Geolocation,
    private modalCtrl: ModalController,
    private locationAccuracy: LocationAccuracy,
    public loadDataService: LoadDataService
  ) { }

  ngOnInit() {}

  ionViewDidEnter() {

    this.geolocation.getCurrentPosition().then( (resp) => {
      this.userCoords = resp.coords;
    });

    this.contentService.getContentsTypes()
        .subscribe ( (resp: TypeContents[] ) => this.typeContents = resp )

    this.activatedRoute.params.subscribe(params => {
      console.log(params);
      this.tagId = params.tagId;
      // this.searchTxt = params.tagName
      
      this.searchTxt = this.loadDataService.selectedTag;

      if ( !this.searchTxt ) {
        this.contentService.getTag( this.tagId )
            .subscribe( (resp: Tag) => {
              this.searchTxt = resp.name
            })
      }
      this.contentService.getContents({
        tagId: this.tagId,
        onlyCurrentSchedules: false
      } as GetContentsRequest)
      .subscribe( (resp: ContentsResults[]) => {
        console.log( resp )
        this.results = resp;
      })

    });

    // if ( !this.list ) {
    //   this.map = new Map('mapId', {zoomControl: false }).setView([-34.603032427989, -58.38137728258387], 6);
    //   tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    //       attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    //   }).addTo(this.map);
  
    //   var greenIcon = icon({
    //     iconUrl: 'assets/map/bxs-map.png',
    //     // shadowUrl: 'leaf-shadow.png',
    
    //     iconSize:     [38, 95], // size of the icon
    //     // shadowSize:   [50, 64], // size of the shadow
    //     // iconAnchor:   [22, 94], // point of the icon which will correspond to marker's location
    //     // shadowAnchor: [4, 62],  // the same for the shadow
    //     popupAnchor:  [-3, -76] // point from which the popup should open relative to the iconAnchor
    //   });
  
    //   var customMarker  = marker([-34.603032427989, -58.38137728258387],{icon: icon({iconUrl: 'assets/map/bxs-map.png', iconSize: [24,30], iconAnchor: [12,30], popupAnchor: [0,0], tooltipAnchor: [0,0]}) }).addTo(this.map);
    //   // const markPoint = marker([-34.603032427989, -58.38137728258387], {icon: greenIcon});
    //   // customMarker.bindPopup("El obelisco").openPopup();
    //   // this.map.addLayer(markPoint)
    // }
    
  }

  switchListToMap(){

    if ( !this.list ) {
      this.map.remove();
      this.list = !this.list;
    } else {
      this.list = !this.list;
      
      this.drawMap(500)
      
    }
    
  }
  drawMap( timeout: number ) {
    const reference = this;

    // Separo los places
    let places = [];
    this.results.forEach( result => {
      result.schedules.forEach( schedule => {
          places.push( schedule.place )
      })
    })
    console.log(places);

    setTimeout(() => {

      
      this.map = new Map('mapId', {zoomControl: false }).setView([-34.603032427989, -58.38137728258387], 12);
      this.map.options.minZoom = 12;
      tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(this.map);

      // const myIcon = divIcon({className: 'div-icon'});

      this.geolocation.getCurrentPosition().then( (resp) => {
        marker([resp.coords.latitude, resp.coords.longitude],{icon: icon({iconUrl: 'assets/icon/ubicacionActual.svg', iconSize: [24,30], iconAnchor: [12,30], popupAnchor: [0,0], tooltipAnchor: [0,0]}) }).addTo(this.map);
      })

      places.forEach( place => {
        const myIcon = divIcon({className: 'div-icon', html: '<img src="'+place.type.iconUrl+'"/>'});
        marker([place.lat, place.lon], {icon: myIcon}).addTo(this.map).on('click', function(e) {
          console.log(place.id);
          reference.openModalPlaces(place.id);
        });
      })
      
      // var customMarker  = marker([-34.603032427989, -58.38137728258387],{icon: icon({iconUrl: 'assets/map/bxs-map.png', iconSize: [24,30], iconAnchor: [12,30], popupAnchor: [0,0], tooltipAnchor: [0,0]}) }).addTo(this.map);

    }, timeout);
  }

  async openModalPlaces(placeId) {
    const modal = await this.modalCtrl.create({
      component: PlaceEventsComponent,
      cssClass: 'transparent-modal-place',
      componentProps: {
        placeId,
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      console.log(data)
      // this.dapartmentId = data;
    }
  }

  changeFilter( type: number, filtro: any, tagName?: string ) {
    console.log( type )
    switch (type) {
      case 0:
        this.filtro = filtro;
        this.filtroName = tagName;
        break;
      case 1:
        this.filtroUbicacion = filtro;
        filtro === 'ubicacion' ? this.openModal() : null;
        break;
      case 2:
        this.filtroFecha = filtro;
        if (filtro === 'esta') {
          this.dateFrom = DateHelper.toString(DateHelper.today())
          this.dateTo = DateHelper.toString(DateHelper.sevenDays())
        } else if (filtro === 'proxima') {
          this.dateFrom = DateHelper.toString(DateHelper.sevenDays())
          this.dateTo = DateHelper.toString(DateHelper.fourteenDays())
        }
        break;
      case 3:
        this.filtroExperiencia = filtro;        
        break;
    }
  }

  clearFilters() {
    this.filtro = null;
    this.filtroName = '';
    this.filtroUbicacion = null;
    this.filtroFecha = null;
    this.filtroExperiencia = null;
  }

  zoomIn() {
    const newZoom = this.map.getZoom() + 1;
    this.map.setZoom(newZoom);
  }

  zoomOut() {
    const newZoom = this.map.getZoom() - 1;
    this.map.setZoom(newZoom);
  }

  userLocation() {

    this.locationAccuracy.canRequest().then((canRequest: boolean) => {

      if(canRequest) {
        // the accuracy option will be ignored by iOS
        this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
          () => {
            console.log('GPS Request successful');

            this.geolocation.getCurrentPosition().then( (resp) => {
              this.map.flyTo([resp.coords.latitude, resp.coords.longitude], 13);
            }, error => console.log(error));
          },
          error => console.log('GPS Error requesting location permissions', error)
        );
      }
    
    });
  }

  modalOpen(){
    this.modalFilters.present();
  }
  filters() {
    this.modalFilters.dismiss();

    this.activatedRoute.params.subscribe(params => {
      console.log(params);
      this.searchTxt = params.tagName
      this.contentService.getContents({
        tagId: params.tagId,
        contentTypeId: this.filtro,
        lon: this.userCoords.longitude ? this.userCoords.longitude.toString() : null,
        lat: this.userCoords.latitude ? this.userCoords.latitude.toString() : null,
        maxDistance: this.filtroUbicacion,
        departamentId: this.dapartmentId,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        eventType: this.filtroExperiencia
      } as GetContentsRequest)
      .subscribe( (resp: ContentsResults[]) => {
        console.log( resp )
        this.results = resp;

        if ( !this.list ) {
          this.map.remove();
          this.drawMap(0);
        }
      })

    });
  }

  async openModal() {
    const modal = await this.modalCtrl.create({
      component: DepartmentModal,
      cssClass: 'transparent-modal'
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      console.log(data)
      this.dapartmentId = data;
    }
  }

}
